<template>
  <div class="account-container">
    <div v-if="accoutData.title" class="title">{{accoutData.title}}</div>
    <van-cell-group>
      <div style="position:relative">
          <van-field class="mobile" v-model="value" maxlength="30" @input="changeVal" :placeholder="accoutData.shadingWords" />
          <div class="tips-con">
          <div class="notips" v-if="isHistoryNo">上次使用</div>
           <div class="clear-btn" @click="clearVal" v-if="isHistoryNo||value"><van-icon name="clear" size="14"/></div>
          </div>
      </div>
    </van-cell-group>
  </div>
</template>
<script>
import delay from '@/utils/debounce'
import { Dialog } from 'vant'
export default {
  name: 'Account',
  data: () => {
    return {
      value: ''
    }
  },
  props: ['accoutData', 'isHistoryNo', 'initValue'],
  watch: {
    initValue(newVal) {
      console.log(newVal, 'change........')
      this.value = newVal
    }
  },
  created () {
     this.value = this.initValue
  },
  methods: {
    triggerBlur (e) {
      const val = e.target.value
      const reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g')
      if (reg.test(val)) {
        Dialog.alert({
          message: '不支持汉字账号'
        }).then(() => {
          // on close
        })
      }
    },
    clearVal() {
       this.value = ''
      this.$emit('changeAccount', '')
    },
    changeVal (val) {
      console.log('change....')
      this.$emit('changeAccount', val)
    }
  }
}
</script>

<style lang="scss" scoped>
.tips-con{
   position: absolute;
   right: 0;
   top: 0;
  height: 100%;
  display: flex;
  align-items: center;
  padding-right: .1rem
}
.clear-btn{
  background: #fff;
  font-size: .10rem;
  color: #a1a3a7;
  border-radius: .05rem;
  white-space: nowrap;
  padding: .05rem;
  right: 0.05rem;
}
.notips{
  background: #fff;
  font-size: .10rem;
  color: #a1a3a7;
  border-radius: .05rem;
  white-space: nowrap;
  padding: .05rem;
}
  .account-container{
    [class*=van-hairline]::after{
      border-top: 0;
    }
    .title{
      margin: .24rem 0 .1rem .1rem;
      text-align: left;
      height: .21rem;
      font-size: .15rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: .21rem;
    }
    .mobile{
        font-size: .15rem;
        font-family: PingFangSC-Regular, PingFang SC;
    }
  }
</style>
